import angular from "angular";
import { AddApplicantToRosterModalComponent } from "./add-applicant-to-roster-modal.component";

export const AddToRosterModule = angular
    .module("apex.mainApp.onboarding.application.addToRoster", [])
    .component("apexAddApplicantToRosterModal", AddApplicantToRosterModalComponent)
    .name;
